import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_brand_values_b_corp: FaireCategoryEntity = {
  token: "cat_brand-values-b-corp",
  type: "category",
  name: "B Corp",
  level: 2,
  parentToken: "cat_brand-values",
  href: "/category/b-corp",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
